import t from "../MaskArray/index.js";

const e = t => t(), r = (t, ...e) => t, s = t => Number.isInteger(Number.parseInt(t, 10)), a = 255, n = "_", i = n.charCodeAt(0), h = new t(a), o = (t, e) => {
    let r = 0, a = 0;
    for (;a < t.length && r < e.length; ) e[r] === i ? (s(t.charAt(a)) && (h[r++] = t.charCodeAt(a)), 
    a++) : (h[r] = e[r], r++);
    return r;
}, l = (t, e) => {
    let r = 0, s = 0;
    for (;r < t.length; ) {
        if (e[r] === i) {
            if (t.charAt(r) === n) break;
            h[s] = t.charCodeAt(r), s++;
        }
        r++;
    }
    return String.fromCharCode.apply(null, 
    // @ts-ignore
    h.subarray(0, s));
}, m = (t, e) => {
    let r = o(t, e);
    for (;r < e.length; r++) h[r] = e[r];
    return String.fromCharCode.apply(null, 
    // @ts-ignore
    h.subarray(0, r));
}, u = (t, e) => {
    let r = o(t, e);
    for (;r < e.length && e[r] !== i; r++) h[r] = e[r];
    return String.fromCharCode.apply(null, 
    // @ts-ignore
    h.subarray(0, r));
}, _ = (t, e) => {
    for (;t < e.length; t++) if (s(e.charAt(t))) return t;
    for (t = 0; t < e.length; t++) if (e.charAt(t) === n) return t;
    return e.length;
};

class d {
    _lastKey="";
    _SUBS=[];
    _needsCursorSync=!1;
    _cursorTimer=0;
    _wasAdded=!1;
    _transformFn=m;
    _transformBackFn=r;
    _maskTypedArray=new t;
    _previousValue="";
    _pos=0;
    _pasteExtraStep=0;
    _onChangeOriginal=r;
    _onKeyDownOriginal=r;
    mask="";
    transformedValue="";
    el=null;
    on=t => (this._SUBS.push(t), () => this._SUBS.splice(this._SUBS.indexOf(t), 1));
    syncCursor() {
        if (this._needsCursorSync && this.el) {
            this._needsCursorSync = !1;
            const t = this._wasAdded ? _(this._pos, this.transformedValue) : Math.min(this._pos, this.transformedValue.length);
            this.el.setSelectionRange(t, t);
        }
    }
    constructor(t) {
        t && this.set(t);
    }
    set({mask: s, dynamic: n, transform: i, value: h, onChange: o, onKeyDown: _}) {
        n ||= !1;
        let d = !1;
        if (this._onChangeOriginal = o || r, this._onKeyDownOriginal = _ || r, this._transformFn = n ? u : m, 
        this._transformBackFn = i ? l : r, s && s !== this.mask) {
            if (s.length >= a) throw new Error(`Maximum MaskInput mask length is 255. Got: ${s.length}`);
            this.mask = s, this._maskTypedArray = new t(s.length);
            for (let t = 0; t < s.length; t++) this._maskTypedArray[t] = s.charCodeAt(t);
            d = !0;
        }
        return "string" == typeof h && h !== this._previousValue && (this._previousValue = h, 
        this.transformedValue = this._transformFn(h, this._maskTypedArray), this.transformedValue === this.mask && (this.transformedValue = ""), 
        d = !0), d && this._SUBS.forEach(e), this;
    }
    events={
        onKeyDown: t => {
            /*
                      No standard way to determine, if pressed key would result in printable character.
                      Doing following assumptions:
                          * printable key has 1 length (Backspace,Enter,etc. have non-1 length)
                          * nobody is printing with alt/ctrl/meta keys pressed. Shift is possible.
                  */
            if (this._lastKey = t.key, this._onKeyDownOriginal(t), this._pasteExtraStep = 0, 
            !(t.ctrlKey || t.altKey || t.metaKey || 1 !== t.key.length && "Unidentified" !== t.key)) {
                const {selectionStart: e, selectionEnd: r} = t.target, s = _(e, this.transformedValue);
                t.target.setSelectionRange(s, Math.max(s, r));
            }
        },
        onPaste: t => {
            /*
                      How many non-SMB_INPUT symbols will be met during paste
                      onPaste should always be executed before onChange
                  */
            this._pasteExtraStep = 0;
            for (let e = t.clipboardData.getData("text"), r = this.el?.selectionStart || 0, a = 0; r < this.mask.length && a < e.length; ) this.mask[r++] !== n && s(e[a++]) && this._pasteExtraStep++;
        },
        onChange: t => {
            const {selectionStart: r, value: s} = t.target;
            let n = s && this._transformFn(s.length < a ? s : s.slice(0, a), this._maskTypedArray);
            0 !== r && "Backspace" !== this._lastKey && "Delete" !== this._lastKey || n !== this.mask || (n = ""), 
            this.el = t.target, this._needsCursorSync = !0, this._wasAdded = s.length > this.transformedValue.length, 
            this._pos = this.transformedValue ? r + this._pasteExtraStep : n.length, n !== this.transformedValue && (this.transformedValue = n, 
            this._onChangeOriginal(this._transformBackFn(n, this._maskTypedArray)), this._SUBS.forEach(e)), 
            cancelAnimationFrame(this._cursorTimer), this._cursorTimer = requestAnimationFrame((() => this.syncCursor()));
        }
    };
    _getTransformedValue=() => this.transformedValue;
}

export { d as default };
//# sourceMappingURL=index.js.map
